<h3 mat-dialog-title>Adicionar Candidato Manualmente</h3>
<mat-dialog-content>
    <form [formGroup]="addCandidateForm" (submit)="submitAddCandidate()" style="width: 100%">
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Filtrar por...</mat-label>
                <mat-select formControlName="filterType">
                    <mat-option value="cpf">CPF</mat-option>
                    <mat-option value="phone">Telefone</mat-option>
                    <mat-option value="email">Email</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Filtro direto</mat-label>
                <input #inputMask matInput type="text" formControlName="filterValue"
                    [mask]="getFieldMask(addCandidateForm.get('filterType').value, inputMask)" />
            </mat-form-field>

            <button mat-icon-button color="primary" type="submit">
                <mat-icon>search</mat-icon>
            </button>

            <button mat-icon-button mat-dialog-close color="accent" type="button">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </form>

    <div class="preview-candidate" *ngIf="candidateToApprove">
        <mat-list>
            <mat-list-item>
                <mat-icon matListIcon *ngIf="candidateToApprove.avatar_profile === null">account_circle</mat-icon>
                <img [src]="mediaEndpoint + candidateToApprove.avatar_profile" matListAvatar
                    *ngIf="candidateToApprove.avatar_profile" />

                <h3 (click)="openCandidate(candidateToApprove)" matLine>{{ candidateToApprove.firstname }} {{
                    candidateToApprove.lastname }}</h3>
                <p (click)="openCandidate(candidateToApprove)" matLine>{{ candidateToApprove.city }}</p>

                <button (click)="aproveCandidate()" mat-icon-button color="primary"
                    matTooltip="Incluir candidato">
                    <mat-icon>check</mat-icon>
                </button>

                <button (click)="rejectCandidate()" mat-icon-button color="accent"
                    matTooltip="Ignorar candidato">
                    <mat-icon>close</mat-icon>
                </button>

            </mat-list-item>
        </mat-list>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="warn" mat-dialog-close>Fechar</button>
</mat-dialog-actions>